'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jobRequests = require('./job-requests.html');

var _jobRequests2 = _interopRequireDefault(_jobRequests);

var _jobRequests3 = require('./job-requests.controller');

var _jobRequests4 = _interopRequireDefault(_jobRequests3);

require('./job-requests.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobRequests = {
  restrict: 'E',
  bindings: {},
  template: _jobRequests2.default,
  controller: _jobRequests4.default,
  controllerAs: 'vm'
};

exports.default = jobRequests;


/** WEBPACK FOOTER **
 ** ./client/app/containers/job-requests/job-requests.component.js
 **/